import React from 'react';
import Modal from '../../../../../components/Modal';
import Table from '../../../../../components/table/Table/Table';
import { columns } from './columns';

const CouponApplyAvailableProductListModal = (props) => {
  const { data, isOpen, closeModal, getList, getProductSubCategoryList } = props;
  const { list, pagination } = data.listData;

  return (
    <Modal
      title="적용 가능 상품"
      isOpen={isOpen}
      width={1500}
      height={600}
      isFooter={true}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="coupon-apply-available-product-list-modal">
        <Table
          className="coupon-apply-available-product-list"
          emptyText="쿠폰 적용 가능 상품이 없습니다."
          data={list}
          pagination={pagination}
          getList={getList}
          showPagination
          columns={() =>
            columns({
              getProductSubCategoryList,
              pageNum: pagination.pageNum,
              pageSize: pagination.pageSize,
            })
          }
        />
      </div>
    </Modal>
  );
};

export default CouponApplyAvailableProductListModal;
